import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom"; // import navigate
import "./RelatedProducts.css";
import { useProductStore } from "../../stores/useProductStores"; 
import Item from "../Items/Item";

const RelatedProducts = () => {
  const { recommendedProducts, getRecommendedProducts } = useProductStore();
  const navigate = useNavigate();

  useEffect(() => {
    getRecommendedProducts(); // Fetch recommended products when the component mounts
  }, [getRecommendedProducts]);

  return (
    <div className="relatedproducts">
      <h1>YOU MAY BE INTERESTED IN</h1>
      <hr />
      <div className="relatedproducts-item">
        {recommendedProducts.length > 0 ? (
          recommendedProducts.map((item) => (
            <div
              key={item.id}
              onClick={() => navigate(`/product/${item.id}`)} // ✅ click to navigate
              style={{ cursor: "pointer" }}
            >
              <Item
                id={item.id}
                name={item.name}
                image={item.image}
                price={item.price}
                availableQuantity={item.available_quantity}
              />
            </div>
          ))
        ) : (
          <p>Loading recommended products...</p>
        )}
      </div>
    </div>
  );
};

export default RelatedProducts;
